import React from 'react';

import { LinearProgress } from '@material-ui/core';

export default function SearchIndicator() {
  return (
    <div style={{ width: '100%' }}>
      <LinearProgress />
    </div>
  );
}
